"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.checkForExternalLink = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LunaLink = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    contentfulId,
    children,
    to,
    href,
    onClick,
    target,
    id,
    className,
    Link,
    style,
    tabIndex,
    rel,
    depth,
    navigate,
    internalLink,
    video,
    setOverride,
    override,
    VideoComponent,
    dataName,
    dataHeading,
    gainsightId,
    ariaLabel,
    htmlTitle,
    englishTextLabel
  } = _ref;
  const handleClick = url => {
    onClick();
    navigate(url);
  };
  if (video) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      //data-sb-object-id={contentfulId ? contentfulId : null} <--placeholder for now
      className: className
      // id={id}
      ,
      style: {
        ...style
      },
      tabIndex: tabIndex,
      onClick: () => setOverride(true),
      "data-depth": depth && depth,
      "data-name": dataName && dataName,
      "data-heading": dataHeading && dataHeading,
      "data-testid": gainsightId,
      "aria-label": ariaLabel && ariaLabel,
      title: htmlTitle ? htmlTitle : null,
      "data-english-text-label": englishTextLabel
    }, children), override && VideoComponent && /*#__PURE__*/_react.default.createElement(VideoComponent, {
      setOverride: setOverride,
      override: override,
      content: video
    }));
  }
  if (Link && to && typeof to === "string" && !checkForExternalLink(to, internalLink)) {
    (0, _react.useImperativeHandle)(ref, e => {
      return {
        handleClick: () => handleClick(to)
      };
    });
    const sbProps = contentfulId ? {
      "data-sb-object-id": contentfulId
    } : null;
    return /*#__PURE__*/_react.default.createElement(Link, _extends({
      className: className,
      to: to,
      onClick: onClick,
      target: target ? target : checkForExternalLink(to, internalLink) ? "_blank" : "_self"
      // id={id}
      ,
      style: {
        ...style
      },
      tabIndex: tabIndex,
      "data-depth": depth && depth,
      "data-name": dataName && dataName,
      "data-heading": dataHeading && dataHeading,
      "data-testid": gainsightId,
      "aria-label": ariaLabel && ariaLabel,
      title: htmlTitle ? htmlTitle : null,
      "data-english-text-label": englishTextLabel
    }, sbProps), children);
  } else {
    const linkDestination = to ? to : href;
    if (linkDestination && typeof linkDestination !== "string" && !linkDestination && !onClick) {
      return null;
    }
    (0, _react.useImperativeHandle)(ref, e => {
      return {
        handleClick: () => handleClick(linkDestination)
      };
    });
    const externalLink = checkForExternalLink(linkDestination, internalLink);
    const sbProps = contentfulId ? {
      "data-sb-object-id": contentfulId
    } : null;
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      className: className,
      href: linkDestination,
      onClick: onClick,
      "data-depth": depth && depth,
      target: target ? target : externalLink ? "_blank" : "_self"
      // id={id}
      ,
      style: {
        ...style
      },
      tabIndex: tabIndex,
      rel: rel || externalLink ? "noopener" : "",
      "data-name": dataName && dataName,
      "data-heading": dataHeading && dataHeading,
      "data-testid": gainsightId,
      title: htmlTitle ? htmlTitle : null,
      "data-english-text-label": englishTextLabel,
      "aria-label": ariaLabel || externalLink ? `Open link in new tab` : "Navigate to link"
    }, sbProps), children);
  }
});
var _default = LunaLink;
exports.default = _default;
const checkForExternalLink = function (link) {
  let internalLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return link && typeof link === "string" && (link?.startsWith("http") || link?.startsWith("www")) && !internalLink;
};
exports.checkForExternalLink = checkForExternalLink;